import { fromJS, Map } from 'immutable';

import { SET_BROWSER_DETAILS } from './actions';

export const BROWSER_DETAILS_KEY = 'browserDetails';

const DEFAULT_STATE = Map({
    oldBrowser: false,
    missingFeature: false,
});

export function browserDetailsReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case SET_BROWSER_DETAILS:
            return fromJS(action);
    }

    return state;
}
